export default __webpack_public_path__ + "static/media/img_background_gradation.26964ab6.png";